import React from 'react';
import Text from 'src/components/Text';
import Button from 'src/components/Button';
import routes from 'src/constants/routes';
import useAuthorization from 'src/dataHooks/useAuthorization';
import { useNavigate } from 'src/utils/useNavigate';
import styles from './styles.module.scss';

const AlfaBank: React.FC = () => {
  const navigate = useNavigate();

  const { authorizationState } = useAuthorization();

  const handleBack = () => {
    navigate(authorizationState?.userId ? routes.agent : routes.main);
  };

  return (
    <div>
      <Text type="p">
        Для оформления договора на СБП с Альфа-Банком нужно заполнить анкету на сайте:{' '}
        <a
          href="https://link.alfabank.ru/acquiring/fast-payment/landing"
          target="_blank"
          className={styles['link']} rel="noreferrer"
        >
          https://link.alfabank.ru/acquiring/fast-payment/landing
        </a>
      </Text>
      <Text type="p">При заполнении анкеты в списке агентов ТСП нужно выбрать "1С".</Text>
      <Button
        variant="outlined"
        width="available"
        onClick={handleBack}
        className={styles['button']}
      >
        Назад
      </Button>
    </div>
  );
};

export default AlfaBank;
